module.exports = __webpack_public_path__ + "static/media/close.a828a9d5.png";